<template>
  <scroll-center-dialog v-model="open" :loading="loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-form ref="form" class="check_box__container">
      <v-checkbox
          false-icon="$custom_checkbox"
          class="check__box"
          color="#3254B9"
          v-model="data.is_mailing"
          :error="hasError('mails_approve')"
          :error-messages="getError('mails_approve')"
      >
        <template v-slot:label>
          <div class="check__box_text">
            Согласие на рассылку
            <br/>рекламной информации
          </div>
        </template>
      </v-checkbox>
  <!--    <div class="field_label__text">ТЕКУЩИЙ ПАРОЛЬ:</div>-->
  <!--    <v-text-field-->
  <!--        class="dialog__fields"-->
  <!--        color="#3254B9"-->
  <!--        base-color="#313743"-->
  <!--        variant="solo"-->
  <!--        v-model="data.password"-->
  <!--        :loading="loading"-->
  <!--        :error="hasError('password')"-->
  <!--        :error-messages="getError('password')"-->
  <!--    >-->
  <!--      <template v-slot:label></template>-->
  <!--    </v-text-field>-->
    </v-form>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog"
import { mapActions } from "vuex"

export default {
  name: "UserMailingDialog",
  props: {
    value: Boolean,
    member: Object
  },
  components: {
    ScrollCenterDialog,
  },
  mixins: [FormErrorsMixin],
  data () {
    return {
      open: false,
      loading: false,
      data: {
        is_mailing: false,
        // password: ''
      },
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open: {
      immediate: true,
      handler () {
        this.$emit('input', this.open)
      }
    }
  },
  computed: {
    form_title () {
      return 'рассылка'
    },
  },
  methods: {
    ...mapActions({
      changeMailings: 'personal_account/members/changeMailings'
    }),
    async save () {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        this.send()
      }
    },
    send () {
      this.loading = true
      this.changeMailings({
        data: { is_mailing: this.data.is_mailing },
        finalizer: () => {
          this.$emit('save')
          this.loading = false
        },
        catcher: (val) => {
          this.mapErrors(val)
          this.loading = false
        },
      })
    },
    loadData () {
      if (this.member !== undefined) {
        this.data.is_mailing = this.member.is_mailing
      }
    },
    close () {
      this.$emit('close')
    },
  },
  created () {
    this.loadData()
  }
}
</script>

<style scoped lang="scss">
.dialog__fields {
  margin-bottom: 5px;
}

.field_label__text {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #3254B9;
}

.check__box {
  margin: 0 auto;
  width: 100%;
  color: #313743;
}

.check__box_text {
  padding-left: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  display: inline-block;
  align-items: center;
  text-align: left;
  color: #313743;
}

@media screen and (max-width: 768px) {
  .field_label__text {
    font-size: 12px;
    line-height: 15px;
  }

  .check__box_text {
    padding-left: 10px;
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
